module.exports = __webpack_public_path__ + "media/tape-nav/commerce-business-help-icon-5b0e13f4.svg";